// Conditional inject helpers — a follow-up card that is injected when a source
// card (or a task inside a Response Action) meets a trigger condition.
// Stored on the follow-up timeline item as `meta.conditional`.

export const CONDITIONAL_CARD_TYPES = [
  { key: 'notification', label: 'Notification', icon: '🔔' },
  { key: 'acknowledgment', label: 'Verification', icon: '✅' },
  { key: 'response_action', label: 'Response Action', icon: '🚨' },
  { key: 'status_update', label: 'Status Update', icon: '🔄' },
];

const SOURCE_LABELS = {
  notification: 'Notification',
  acknowledgment: 'Verification',
  response_action: 'Response Action',
  status_update: 'Status Update',
  resource: 'Resource',
};

export const sourceCardTypeLabel = (item) =>
  SOURCE_LABELS[item?.group] || 'Card';

// Outcome options available as a trigger, depending on the source card type.
export const outcomeOptionsForSource = (group) => {
  switch (group) {
    case 'acknowledgment':
      return ['Confirmed', 'False Alarm'];
    case 'response_action':
      return ['Performed'];
    case 'notification':
      return ['Acknowledged'];
    default:
      return [];
  }
};

// Build a short human label for the source, used on the conditional chip.
export const buildSourceLabel = (item, taskIndex = null) => {
  const base = sourceCardTypeLabel(item);
  if (taskIndex != null) return `${base} · Task ${taskIndex + 1}`;
  return base;
};

// Describe the trigger condition for display on the chip.
export const describeConditional = (c) => {
  if (!c) return '';
  const within = c.withinMinutes != null && c.withinMinutes !== ''
    ? `${c.withinMinutes}m`
    : '';
  if (c.triggerType === 'timeout') return `if not completed within ${within}`;
  if (c.triggerType === 'completed') return `if completed within ${within}`;
  if (c.triggerType === 'outcome') return `if outcome is “${c.outcome}”`;
  return '';
};

// Full chip text shown on a nested conditional card.
export const conditionalChipText = (c) => {
  if (!c) return '';
  return `Triggers ${describeConditional(c)} on ${c.sourceLabel || 'source'}`;
};
